import { useEffect, useMemo } from 'react';
import { Box } from '@mui/material';
import { ImmutableDataTable } from '@components';
import { usePendingSignupsTable, PendingSignupTableRow } from '../hooks/usePendingSignupsTable';
import { getPendingSignupsTableColumns } from '../utils/pendingSignupsTableColumns';

type PendingSignupsTableProps = {
  pageNumber: number;
  pageSize: number;
  searchQuery: string;
  onPageReset: () => void;
  onTotalChange: (total: number) => void;
};

const PendingSignupsTable = ({
  pageNumber,
  pageSize,
  searchQuery,
  onPageReset,
  onTotalChange,
}: PendingSignupsTableProps) => {
  const {
    rows,
    isLoading,
    total,
    sort,
    sortOrder,
    handleSort,
    statusFilter,
    handleStatusFilterChange,
    feedbackSubmittedFilter,
    handleFeedbackSubmittedFilterChange,
  } = usePendingSignupsTable({ pageNumber, pageSize, searchQuery, onPageReset });

  useEffect(() => {
    onTotalChange(total);
  }, [total, onTotalChange]);

  const columns = useMemo(
    () =>
      getPendingSignupsTableColumns({
        sort,
        sortOrder,
        onSort: handleSort,
        statusFilter,
        onStatusFilterChange: handleStatusFilterChange,
        feedbackSubmittedFilter,
        onFeedbackSubmittedFilterChange: handleFeedbackSubmittedFilterChange,
      }),
    [
      sort,
      sortOrder,
      handleSort,
      statusFilter,
      handleStatusFilterChange,
      feedbackSubmittedFilter,
      handleFeedbackSubmittedFilterChange,
    ],
  );

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <Box sx={{ '& .MuiTableBody-root .MuiTableCell-root': { border: '1px solid #2F736E1F' } }}>
        <ImmutableDataTable<PendingSignupTableRow>
          data={rows}
          columns={columns}
          meta={{
            totalCount: total,
            currentPage: pageNumber,
            pageSize,
          }}
          isLoading={isLoading}
        />
      </Box>
    </Box>
  );
};

export default PendingSignupsTable;
